/* eslint-disable */
export default [
	{
		path: '/login',
		name: 'auth-login',
		component: () => import('@/views/client/auth/Login.vue'),
		meta: {
		isPublic: true,
			layout: 'full',
			resource: 'Auth',
			redirectIfLoggedIn: true
		}
	}
]